import subscriptionProducts from "./subscriptionProducts";
import attributes from "./attributes";
import attributeOptions from "./attributeOptions";
import variants from "./variants";
import shop from "./shop";

export default {
    namespaced: true,

    modules: {
        subscriptionProducts,
        attributes,
        attributeOptions,
        variants,
        shop
    },
};
